import mesh from "@/app/assets/mesh.webp";

export const meshBackgroundStyle = {
    backgroundImage: `url("${mesh.src}")`,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
};
